import { EM_DASH } from "routes/custom_tables/grid/cellHelpers";

export default function BooleanCell({ value }) {
  return value == null ? (
    <span className="tw:text-muted-foreground">{EM_DASH}</span>
  ) : (
    <span className="tw:inline-flex tw:items-center tw:gap-1.5 tw:select-none">
      <span
        className="tw:size-2 tw:rounded-full tw:bg-muted-foreground tw:data-[on=true]:bg-primary"
        data-on={String(value)}
      />
      <span>{value ? "Yes" : "No"}</span>
    </span>
  );
}
